import * as _ from 'lodash';
import { useEffect, useState } from 'react';
import { connect, Dispatch } from 'react-redux';
import { CenterActionCreators, IApplicationState, IAppState, ICenterProfileLookupData, ICenterProfileLookupDataResponse, initialCenterProfileLookupData } from '@nkr/store/index';
import { ICenterAddress, IDocumentsVersion, IDropDownItem, IListItem, ISerologyTest, IContact, IOpoForCenterProfile } from '@nkr/models/index';
import { editNavKey, navTabs } from './edit-nav-key';
import { IErrorItem } from '../error-item';
import { Alert } from 'react-bootstrap';
import { ContainerWrapper } from './styles';
import CenterSrtrDataTab from './srtr';
import CenterUnosDataTab from './unos-data';
import CenterProfileTab from './profile-data';
import CenterLabDataTab from './lab';
import CenterServicesTab from './services';
import CenterSerologyTab from './serology';
import CenterAnatomyPrefsTab from './anatomy-preferences';
import CenterLegalDocumentsTab from './legal-documents';
import DataChangedWarning from './data-changed-warning';
import CenterAdminTab from './admin';
import CenterTaxesTab from './taxes';
import PackagingTab from './packaging';

interface IProps {
    centerId: number,
    activeKey: string,
    isAdmin: boolean,
    isAdminUser: boolean
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    getLookupData: (centerId: number, organType?: number) => Promise<ICenterProfileLookupDataResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

const CenterProfileEditContainer = (props: TProps) => {
    const [hasDataChanged, setHasDataChanged] = useState(false);
    const [dataChangedWarning, setDataChangedWarning] = useState({ show: false, href: '' });
    const [errorList, setErrorList] = useState<IErrorItem[]>([]);
    const [lookupData, setLookupData] = useState<ICenterProfileLookupData>({...initialCenterProfileLookupData});
    // const [opoList, setOpoList] = useState<IOpoForCenterProfile[]>([]);
    // const [xmVirtualOptionList, setXmVirtualOptionList] = useState<IListItem[]>([]);
    // const [requiredTubeList, setRequiredTubeList] = useState<IListItem[]>([]);
    // const [pairWorkupList, setPairWorkupList] = useState<IListItem[]>([]);
    // const [workupWaitList, setWorkupWaitList] = useState<IListItem[]>([]);
    // const [serologyTestList, setSerologyTestList] = useState<ISerologyTest[]>([]);
    // const [documentVersionList, setDocumentVersionList] = useState<IDocumentsVersion[]>([]);
    // const [staffList, setStaffList] = useState<IListItem[]>([]);
    // const [micrositeCoachList, setMicrositeCoachList] = useState<IListItem[]>([]);
    // const [centerAddressList, setCenterAddressList] = useState<ICenterAddress[]>([]);
    // const [anatomyMaxPreferenceLeftList, setAnatomyMaxPreferenceLeftList] = useState<IListItem[]>([]);
    // const [anatomyMaxPreferenceRightList, setAnatomyMaxPreferenceRightList] = useState<IListItem[]>([]);

    useEffect(() => {
        props.getLookupData(props.centerId, props.app.site.organType).then(response => {
            if (response.data.success) {
                // let {
                //     opoList, xmVirtualOptionList, requiredTubeList, pairWorkupList, workupWaitList, serologyTestList,
                //     documentVersionList,
                //     staffList,
                //     micrositeCoachList,
                //     centerAddressList,
                //     anatomyMaxPreferenceLeftList, anatomyMaxPreferenceRightList,
                //     coordinatorList
                // } = response.data.results;

                setLookupData(response.data.results);

                // setOpoList(opoList);
                // setXmVirtualOptionList(xmVirtualOptionList);
                // setRequiredTubeList(requiredTubeList);
                // setPairWorkupList(pairWorkupList);
                // setWorkupWaitList(workupWaitList);
                // setSerologyTestList(serologyTestList);
                // setDocumentVersionList(documentVersionList);
                // setStaffList(staffList);
                // setMicrositeCoachList(micrositeCoachList);
                // setCenterAddressList(centerAddressList);
                // setAnatomyMaxPreferenceLeftList(anatomyMaxPreferenceLeftList);
                // setAnatomyMaxPreferenceRightList(anatomyMaxPreferenceRightList);
            }
        });
    }, []);

    const handleTabClick = (href: string) => {
        if (hasDataChanged) {
            setDataChangedWarning({
                show: true,
                href
            });
        } else {
            window.location.href = href;
        }
    };

    const handleDiscardChanges = () => {
        let href = dataChangedWarning.href;

        setDataChangedWarning({
            show: false,
            href: ''
        });

        window.location.href = href;
    };

    const handleCancelWarning = () => {
        setDataChangedWarning({
            show: false,
            href: ''
        });
    };

    const handleDataChanged = (hasDataChanged: boolean) => {
        setHasDataChanged(hasDataChanged);
    };

    const handleUpdateErrors = (errorList: IErrorItem[]) => {
        setErrorList(errorList);
    };

    const renderValidationAlert = () => {
        let tab = navTabs.find(x => x.key == props.activeKey);

        return (
            <Alert bsStyle='danger' bsSize='sm'>
                <div style={{ marginBottom: 10 }}>Please resolve the following issues before saving:</div>

                <blockquote style={{ margin: 0 }}>
                    <ul>
                        <li style={{ listStyleType: 'disc' }}>{tab != null ? tab.name : ''}</li>
                        <ul>
                            {errorList.map(item =>
                                <li style={{ listStyleType: 'circle' }}><strong>{item.field}:</strong> {item.desc}</li>
                            )}
                        </ul>
                    </ul>
                </blockquote>
            </Alert>
        );
    };

    const timezones: IDropDownItem[] = [
        { value: 'PST', display: 'PST' },
        { value: 'MST', display: 'MST' },
        { value: 'PHO', display: 'MST - No DST' },
        { value: 'CST', display: 'CST' },
        { value: 'EST', display: 'EST' },
        { value: 'HST', display: 'HST' },
    ];

    return (
        <>
            <ContainerWrapper className='container-fluid'>
                {errorList.length > 0 && (
                    <>{renderValidationAlert()}</>
                )}

                {props.activeKey == editNavKey.ADMIN && props.isAdminUser && (
                    <CenterAdminTab
                        centerId={props.centerId}
                        isAdmin={props.isAdmin}
                        isAdminUser={props.isAdminUser}
                        hasDataChanges={hasDataChanged}
                        staffList={lookupData.staffList}
                        micrositeCoachList={lookupData.micrositeCoachList}
                        documentVersionList={lookupData.documentVersionList}
                        onTabClick={handleTabClick}
                        onDataChanged={handleDataChanged}
                        updateErrors={handleUpdateErrors}
                    />
                )}

                {props.activeKey == editNavKey.SRTR && props.isAdminUser && (
                    <CenterSrtrDataTab
                        centerId={props.centerId}
                        isAdmin={props.isAdmin}
                        isAdminUser={props.isAdminUser}
                        hasDataChanges={hasDataChanged}
                        onTabClick={handleTabClick}
                        onDataChanged={handleDataChanged}
                        updateErrors={handleUpdateErrors}
                    />
                )}

                {props.activeKey == editNavKey.TAX && props.isAdminUser && (
                    <CenterTaxesTab
                        centerId={props.centerId}
                        isAdmin={props.isAdmin}
                        isAdminUser={props.isAdminUser}
                        hasDataChanges={hasDataChanged}
                        onTabClick={handleTabClick}
                        onDataChanged={handleDataChanged}
                        onUpdateErrors={handleUpdateErrors} />
                )}

                {props.activeKey == editNavKey.UNOS && props.isAdminUser && (
                    <CenterUnosDataTab
                        centerId={props.centerId}
                        isAdmin={props.isAdmin}
                        isAdminUser={props.isAdminUser}
                        hasDataChanges={hasDataChanged}
                        onTabClick={handleTabClick}
                        onDataChanged={handleDataChanged}
                        updateErrors={handleUpdateErrors}
                    />
                )}

                {props.activeKey == editNavKey.CENTER_DATA && (
                    <CenterProfileTab
                        centerId={props.centerId}
                        isAdmin={props.isAdmin}
                        isAdminUser={props.isAdminUser}
                        hasDataChanges={hasDataChanged}
                        timeZoneList={timezones}
                        documentVersionList={lookupData.documentVersionList}
                        coordinatorList={lookupData.coordinatorList}
                        onTabClick={handleTabClick}
                        onDataChanged={handleDataChanged}
                        updateErrors={handleUpdateErrors}
                    />
                )}

                {props.activeKey == editNavKey.LAB && (
                    <CenterLabDataTab
                        centerId={props.centerId}
                        isAdmin={props.isAdmin}
                        isAdminUser={props.isAdminUser}
                        hasDataChanges={hasDataChanged}
                        xmVirtualOptionList={lookupData.xmVirtualOptionList}
                        requiredTubeList={lookupData.requiredTubeList}
                        onTabClick={handleTabClick}
                        onDataChanged={handleDataChanged}
                        updateErrors={handleUpdateErrors}
                    />
                )}

                {props.activeKey == editNavKey.SERVICES && (
                    <CenterServicesTab
                        centerId={props.centerId}
                        isAdmin={props.isAdmin}
                        isAdminUser={props.isAdminUser}
                        hasDataChanges={hasDataChanged}
                        pairWorkupList={lookupData.pairWorkupList}
                        workupWaitList={lookupData.workupWaitList}
                        onTabClick={handleTabClick}
                        onDataChanged={handleDataChanged}
                        updateErrors={handleUpdateErrors}
                    />
                )}

                {props.activeKey == editNavKey.SEROLOGY_TESTS && (
                    <CenterSerologyTab
                        centerId={props.centerId}
                        organType={props.app.site.organType}
                        isAdmin={props.isAdmin}
                        isAdminUser={props.isAdminUser}
                        hasDataChanges={hasDataChanged}
                        serologyTestList={lookupData.serologyTestList}
                        centerAddressList={lookupData.centerAddressList}
                        onTabClick={handleTabClick}
                        onDataChanged={handleDataChanged}
                        updateErrors={handleUpdateErrors} />
                )}

                {props.activeKey == editNavKey.ANATOMY_PREFS && (
                    <CenterAnatomyPrefsTab
                        centerId={props.centerId}
                        isAdmin={props.isAdmin}
                        isAdminUser={props.isAdminUser}
                        hasDataChanges={hasDataChanged}
                        anatomyMaxPreferenceLeftList={lookupData.anatomyMaxPreferenceLeftList}
                        anatomyMaxPreferenceRightList={lookupData.anatomyMaxPreferenceRightList}
                        onTabClick={handleTabClick}
                        onDataChanged={handleDataChanged}
                        updateErrors={handleUpdateErrors} />
                )}

                {props.activeKey == editNavKey.LEGAL_DOCUMENTS && (
                    <CenterLegalDocumentsTab
                        centerId={props.centerId}
                        isAdmin={props.isAdmin}
                        isAdminUser={props.isAdminUser}
                        onTabClick={handleTabClick}
                    />
                )}

                {props.activeKey == editNavKey.PACKAGING && (
                    <PackagingTab
                        centerId={props.centerId}
                        isAdmin={props.isAdmin}
                        isAdminUser={props.isAdminUser}
                        hasDataChanges={hasDataChanged}
                        opoList={lookupData.opoList}
                        onTabClick={handleTabClick}
                        onDataChanged={handleDataChanged}
                        updateErrors={handleUpdateErrors} />
                )}
            </ContainerWrapper>

            <DataChangedWarning
                show={dataChangedWarning.show}
                tabKey={props.activeKey}
                onDiscard={handleDiscardChanges}
                onCancel={handleCancelWarning}
            />
        </>
    );
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        app: appState.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        getLookupData: (centerId, organType) => {
            return dispatch(CenterActionCreators.getCenterProfileLookupData(centerId, organType));
        }
    }
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(CenterProfileEditContainer);
